import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  userStateComponent: {},
};

const userComponentSlice = createSlice({
  name: "userComponent",
  initialState,
  reducers: {
    setStateComponent(state, action) {
      // Merge payload and payload2 into userStateComponent
      state.userStateComponent = {
        ...action.payload,
        ...action.payload2,
      };
    },
  },
});

export const { setStateComponent } = userComponentSlice.actions;
export default userComponentSlice.reducer;
